{
  "qr-checkin-config-page": {
    "buttons": {
      "check-in": "CHECK IN"
    },
    "meta": {
      "title": "QR-Check-in",
      "description": "Einchecken per QR-Code",
      "checkin-hint": "(Optional) Sie können Ihren Service vor dem Check-in wählen"
    }
  }
}
